export const colors = {
    // Neutral palette
    'Neutral0': '#FFFFFF',
    'Neutral1': '#F8F9FC',
    'Neutral2': '#F0F2F9',
    'Neutral3': '#DDDFE5',
    'Neutral4': '#CACCD2',
    'Neutral5': '#B8B9BE',
    'Neutral6': '#929397',
    'Neutral7': '#7F8084',
    'Neutral8': '#6C6D70',
    'Neutral9': '#595A5D',
    'Neutral10': '#474749',
    'Neutral11': '#343436',
    'Neutral12': '#1A1A1B',
    'Neutral13': '#000000',
    // Blue palette
    'Blue0': '#F0F6FF',
    'Blue1': '#D8E8FF',
    'Blue2': '#B6D2FF',
    'Blue3': '#69A3FF',
    'Blue4': '#0063FF',
    'Blue5': '#014FCB',
    'Blue6': '#013B97',
    'Blue7': '#102C55',
    'Blue8': '#4C6180',
    'Blue9': '#8896AA',
    // Yellow palette
    'Yellow0': '#FFFBC1',
    'Yellow1': '#FEF5A0',
    'Yellow2': '#FDE75F',
    'Yellow3': '#FCDA1D',
    'Yellow4': '#D3B718',
    'Yellow5': '#AA9313',
    'Yellow6': '#80700E',
    'Yellow7': '#2E2904',
    // Green palette
    'Green0': '#C6FFD9',
    'Green1': '#87FFBB',
    'Green2': '#5CF5A7',
    'Green3': '#33E497',
    'Green4': '#1DCC77',
    'Green5': '#019E57',
    'Green6': '#006B3E',
    'Green7': '#004D2D',
    // Red palette
    'Red0': '#F9E2E1',
    'Red1': '#F3B1AF',
    'Red2': '#EB7B77',
    'Red3': '#C8322A',
    'Red4': '#9F2821',
    'Red5': '#761E19',
    'Red6': '#6A1B16',
    'Red7': '#5F1814',
    // Utility
    'Transparent': 'transparent',
}